import React, { useState } from 'react';
import CheckBox from '../../settings-menu/Checkbox';
import { BetslipContext } from '../../../data/betslip/BetslipConf';
import { getConfiguration } from '../../../data/utils/configuration';
import { getCurrencyValue } from '../../../data/utils/getCurrencyValue';
import { getLabel } from '../../../data/labels';
import MenuInfo from '../../settings-menu/MenuInfo';
import { FastbetPopup } from './FastbetPopup';

export default function FastbetToggle() {
    const betslipContext = React.useContext(BetslipContext);
    const [toggled, setToggled] = useState(false);

    function toggle() {
        setToggled(!toggled);
    }

    const conf = getConfiguration();
    const amount = getCurrencyValue(betslipContext.addAndBetAmount, conf.cs.m, conf.cs.nd, conf.cs.ct);

    function toggleFastbet() {
        if (betslipContext.isAddAndBetEnabled()) {
            betslipContext.disableAddAndBet();
        } else {
            toggle();
        }
    }

    const isEnabled = betslipContext.isAddAndBetEnabled();
    
    return (
        <>
            <div className="grid grid-cols-12 items-center border-t border-t-cs7 last:border-b last:border-b-cs7">
                <div className="col-start-1 col-end-9 pl-2 flex items-center">
                    {isEnabled ?
                        <>
                            <span className="font-normal text-sm text-[#000]">{getLabel('settings.fastbet') || getLabel('general.fastbet')}</span>
                            <div className="px-2 ml-2 flex items-center rounded-md bg-cs7" onClick={toggle}>{amount}</div>
                        </>
                        :
                        <span className="font-normal text-sm text-[#000]">{getLabel('settings.fastbet') || getLabel('general.fastbet')}</span>
                    }
                </div>
                <div className="col-start-9 col-end-10 flex items-center justify-center">
                    <MenuInfo index={1} />
                </div>
                <div className="col-start-10 col-end-13 flex items-center justify-center">
                    <CheckBox id="fast-bet-cb"
                            checked={isEnabled}
                            onChange={toggleFastbet} />
                </div>
            </div>
            {toggled &&
                <FastbetPopup toggle={toggle} />
            }
        </>
    );
}
